import { defineComponent, inject } from 'vue'
import { useNamespace } from '@lit-element/hooks'
import { EditorMdInjectionKey } from '../editor-md-types'
import { FONT_SIZE_LIST } from '../toolbar-config'
import type { IEditorMdInjection } from '../editor-md-types'

const ns = useNamespace('md-dropdown')

export default defineComponent({
  name: 'FontSize',
  setup() {
    const { getEditorIns } = inject(EditorMdInjectionKey) as IEditorMdInjection
    const setSize = (val: number) => {
      const editorIns = getEditorIns()
      const selection = editorIns.getSelection()
      editorIns.focus()
      editorIns.replaceSelection(
        `<span style="font-size:${val}px;">${selection}</span>`
      )
      setTimeout(() => {
        if (selection === '') {
          const cursor = editorIns.getCursor()
          editorIns.setCursor(cursor.line, cursor.ch - 7)
        }
      })
    }

    return () => (
      <ul class={ns.b('font-size')}>
        {FONT_SIZE_LIST.map((item, index) => (
          <li key={index} onClick={() => setSize(item.value)}>
            {item.name}
          </li>
        ))}
      </ul>
    )
  },
})
